export default __webpack_public_path__ + "static/media/trash.da413092.svg";